import React, { useState, useRef, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './App.css';
import logo from './designarena_image_lz5bj7ue.png';
import './LandingPage.css';
import './ChallanForm.css';

// --- CONFIGURATION: FORCE DESKTOP LAYOUT FOR EXPORTS ---
const CAPTURE_CONFIG = {
  scale: 3,                 // High Resolution (Retina quality)
  useCORS: true,            
  backgroundColor: '#ffffff',
  windowWidth: 1600,        // Force Desktop CSS Media Queries
  width: 900,               // Force Exact Paper Width
  x: 0,
  y: 0,
  // --- THE MOBILE FIX ---
  // This runs on the invisible clone before capturing.
  // It forces the paper back to 100% scale so the image isn't tiny.
  onclone: (clonedDoc) => {
    const scaler = clonedDoc.querySelector('.challan-scaler');
    if (scaler) {
      scaler.style.transform = 'scale(1)'; // Reset Zoom
      scaler.style.margin = '0';           // Remove Mobile Margins
    }
  }
};

// --- LANDING PAGE ---
const LandingPage = ({ onStart }) => {
  const [showContact, setShowContact] = useState(false);

  return (
    <div className="landing-container">
    <nav className="gov-header">
      <div className="gov-logo">
        <span className="emblem">
          <img src={logo} alt="Emblem" className="emblem-img" style={{width:'80px'}} />
        </span>
        <div className="gov-text">
          <span className="gov-title">GOVERNMENT OF NON-CHALANCE</span>
          <span className="gov-subtitle">Ministry of Masculine Virtues</span>
        </div>
      </div>
      <div className="login-link">OFFICIAL LOGIN 🔒</div>
    </nav>
    <div className="ticker-wrap">
      <div className="ticker">
        <div className="ticker-item">⚠️ NOTICE: "Seen-zoned" is now a punishable offence under Section 420.</div>
        <div className="ticker-item">📢 UPDATE: 500/- Penalty for not replying within 0.5 seconds.</div>
      </div>
    {/* CONTACT US MODAL */}
      {showContact && (
        <div className="modal-overlay" onClick={() => setShowContact(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowContact(false)}>×</button>
            <h3 style={{ marginTop: 0, marginBottom: '15px' }}>Contact Us</h3>
            <p style={{ margin: '10px 0' }}>
              Instagram: <a href="https://instagram.com/vinalayak" target="_blank" rel="noreferrer" className="contact-link">@vinalayak</a>
            </p>
            <p style={{ margin: '10px 0' }}>
              Email: <a href="mailto:vinayakchawlaofficial@gmail.com" className="contact-link">vinayakchawlaofficial@gmail.com</a>
            </p>
          </div>
        </div>
      )}
  
    </div>
    <main className="main-content">
      <div className="challan-card">
        <h1 className="landing-title">CNCMA <span className="highlight">e-PORTAL</span></h1>
        <h2 className="landing-subtitle">Challan-ed Non-Chalant Men Association</h2>
        <div className="legal-reference">
          <p>Infringement Report under <strong>Cultivation of Healthy Masculine Virtues Act, 2026</strong></p>
        </div>
        <div className="info-box">
          <p><strong>System Status:</strong> <span className="blink">Operational</span></p>
          <p><strong>Ref No:</strong> CNCMA/2026/V-DAY/001</p>
        </div>
        <button className="btn-primary" onClick={onStart}>
          <span className="btn-text">GENERATE E-CHALLAN</span>
        </button>
      </div>
    </main>
    <footer className="footer">
  <p>© 2026 CNCMA. Designed by National Informatics Centre of Heartbreak (NICH).</p>
  <div className="footer-links">
    Terms of Service | <a href="/grievance.jpg" target="_blank" rel="noreferrer">Grievance Redressal</a> | <a href="#contact" onClick={(e) => { e.preventDefault(); setShowContact(true); }}>Contact Us</a>
  </div>
</footer>
  </div>
  );
};

// --- FORM COMPONENT ---
const ChallanForm = ({ onSubmit, onHome }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const PREDEFINED_OFFENCES_PARTNER = [
    "Not watching reels sent by partner", "Leaving the toilet seat up", "Not asking 'what happened' when she said 'I'm fine'",
    "Playing FIFA/BGMI during important gossip session", "Replying with 'K' or '👍'", "Forgot Month-iversary", "Breathing too loudly"
  ];
  const PREDEFINED_OFFENCES_FRIEND = [
    "Canceling group trip at the last moment 🤡",
    "Not watching reels I sent 📱", 
    "Not paying back ₹5/₹10 💸", 
    "Saying '5 min' but still at home 🐢", 
    "Eating without informing 🍕"
  ];
  
  const [formData, setFormData] = useState({
    relationshipType: 'Partner', /* NEW FIELD */
    violatorName: '', 
    victimName: '', 
    challanNumber: `CNCMA/${new Date().getFullYear()}/420-${Math.floor(Math.random() * 1000)}`,
    dateOfIncident: new Date().toISOString().split('T')[0], 
    place: '',
    offence: PREDEFINED_OFFENCES_PARTNER[0], 
    fineAmount: '500', 
    upiId: '',
    paymentMode: 'Roses', 
    remarks: 'Violator apologises for his actions and assures better reading between the moods in the future.',
    evidenceImages: [], 
    repeatViolator: 'No', 
    agreed: false
  });

  const activeOffences = formData.relationshipType === 'Partner' ? PREDEFINED_OFFENCES_PARTNER : PREDEFINED_OFFENCES_FRIEND;
  const [offenceSelection, setOffenceSelection] = useState(activeOffences[0]);

  // Auto-switch offences when relationship type changes
  // Auto-switch offences when relationship type changes
  useEffect(() => {
    setOffenceSelection(activeOffences[0]);
    setFormData(prev => ({ ...prev, offence: activeOffences[0] }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.relationshipType]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleOffenceChange = (e) => {
    const val = e.target.value;
    setOffenceSelection(val);
    setFormData(prev => ({ ...prev, offence: val === "Custom" ? '' : val }));
  };

  const handleImageUpload = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files).slice(0, 3);
      setFormData(prev => ({ ...prev, evidenceImages: files.map(f => URL.createObjectURL(f)) }));
    }
  };

  const submitToGoogleSheets = async (data) => {
    const scriptURL = 'https://script.google.com/macros/s/AKfycbzIzAVq6Cjh1ZqXpGiRWPZW1oJMIKhdwxfZnvcfvC42H3BDhDpWq67t_RqYxDj1iDnx/exec'; 
    if (scriptURL === 'YOUR_GOOGLE_SCRIPT_URL_HERE') return;
    const formBody = new FormData();
    Object.keys(data).forEach(key => formBody.append(key, data[key]));
    try { await fetch(scriptURL, { method: 'POST', body: formBody }); } catch (error) { console.error('Error!', error.message); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(formData.agreed) {
        setIsSubmitting(true);
        await submitToGoogleSheets(formData);
        setIsSubmitting(false);
        onSubmit(formData);
    } else { alert("Please sign the Declaration."); }
  };

  return (
    <div className="form-wrapper">
      <div className="official-paper">
        <button onClick={onHome} style={{ background: 'transparent', border: 'none', color: '#666', cursor: 'pointer', marginBottom: '10px' }}>← Back to Home</button>
        <div className="form-header-strip"><span>FORM NO. 420-B</span><span>NON-CHALANCE REGISTRY</span></div>
        <div className="watermark">CONFIDENTIAL</div>
        <h2 className="form-title">DRAFT INFRINGEMENT REPORT</h2>
        <div className="challan-meta"><span><strong>REF NO:</strong> {formData.challanNumber}</span><span><strong>DATE:</strong> {new Date().toLocaleDateString()}</span></div>
        <hr className="divider-dotted" />
        <form onSubmit={handleSubmit}>
          
          <fieldset className="form-section"><legend>SECTION I: PARTICULARS</legend>
            <div className="form-group full-width" style={{ marginBottom: '15px' }}>
               <label>CHALLAN CATEGORY</label>
               <div className="radio-group">
                  <label className="radio-label">
                    <input type="radio" name="relationshipType" value="Partner" checked={formData.relationshipType === 'Partner'} onChange={handleChange} /> PARTNER
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="relationshipType" value="Friend" checked={formData.relationshipType === 'Friend'} onChange={handleChange} /> FRIEND
                  </label>
               </div>
            </div>

            <div className="grid-2">
              <div className="form-group"><label>ACCUSED</label><input required name="violatorName" value={formData.violatorName} onChange={handleChange} placeholder="e.g. Aditya" /></div>
              <div className="form-group"><label>VICTIM</label><input required name="victimName" value={formData.victimName} onChange={handleChange} placeholder="e.g. Geet" /></div>
            </div>
          </fieldset>

          <fieldset className="form-section"><legend>SECTION II: INCIDENT</legend>
            <div className="grid-2">
              <div className="form-group"><label>PLACE</label><input name="place" value={formData.place} onChange={handleChange} placeholder="" /></div>
              <div className="form-group"><label>DATE</label><input type="date" name="dateOfIncident" value={formData.dateOfIncident} onChange={handleChange} /></div>
            </div>
            
            <div className="form-group full-width">
               <label>IS REPEAT VIOLATOR?</label>
               <div className="radio-group" style={{display:'flex', gap:'20px', marginTop:'5px'}}>
                  <label className="radio-label">
                    <input type="radio" name="repeatViolator" value="Yes" checked={formData.repeatViolator === 'Yes'} onChange={handleChange} /> YES
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="repeatViolator" value="No" checked={formData.repeatViolator === 'No'} onChange={handleChange} /> NO
                  </label>
               </div>
            </div>

            <div className="form-group full-width"><label>OFFENCE</label>
                <select value={offenceSelection} onChange={handleOffenceChange} className="form-control" style={{marginBottom: offenceSelection === 'Custom' ? '10px' : '0'}}>
                    {activeOffences.map((o, i) => <option key={i} value={o}>{o}</option>)}
                    <option value="Custom">Other...</option>
                </select>
                {offenceSelection === 'Custom' && <input name="offence" value={formData.offence} onChange={handleChange} className="form-control" style={{ borderLeft: '4px solid #d32f2f' }} required />}
            </div>

            <div className="form-group full-width"><label>EVIDENCE (optional; choose upto 3)</label>
                <input type="file" multiple accept="image/*" onChange={handleImageUpload} />
                <p className="upload-disclaimer">*Your images remain on your device. We do not store or retain any sensitive information.</p>
                <div className="image-preview-row">{formData.evidenceImages.map((src, i) => <img key={i} src={src} className="preview-thumb" alt="prev"/>)}</div>
            </div>
          </fieldset>

          <fieldset className="form-section"><legend>SECTION III: PENALTY</legend>
            
            <div className="form-group full-width" style={{ marginBottom: '15px' }}>
               <label>PAYMENT MODE</label>
               <div className="radio-group">
                  <label className="radio-label">
                    <input type="radio" name="paymentMode" value="Roses" checked={formData.paymentMode === 'Roses'} onChange={handleChange} /> ROSES
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="paymentMode" value="Cash / UPI" checked={formData.paymentMode === 'Cash / UPI'} onChange={handleChange} /> CASH / UPI
                  </label>
               </div>
            </div>

            <div className="grid-2">
                <div className="form-group">
                  <label>FINE {formData.paymentMode === 'Roses' ? '(QTY)' : '(INR)'}</label>
                  <input type="number" name="fineAmount" value={formData.fineAmount} onChange={handleChange} />
                </div>
                
                {formData.paymentMode === 'Cash / UPI' && (
                    <div className="form-group">
                      <label>UPI ID (optional)</label>
                      <input name="upiId" value={formData.upiId} onChange={handleChange} />
                    </div>
                )}
            </div>
            <div className="form-group full-width"><label>REMARKS</label><textarea name="remarks" value={formData.remarks} onChange={handleChange} className="handwritten-font"/></div>
          </fieldset>
          
          <div className="declaration-box"><label className="checkbox-container"><input type="checkbox" name="agreed" checked={formData.agreed} onChange={handleChange} /> I hereby declare that the information above is true to my overthinking and delusion.</label></div>
          <button type="submit" className="btn-issue" disabled={isSubmitting}><span>{isSubmitting ? 'GENERATING...' : '⚖️ ISSUE OFFICIAL CHALLAN'}</span></button>
        </form>
      </div>
    </div>
  );
};

// --- DISPLAY COMPONENT ---
const ChallanDisplay = ({ data, onBack }) => {
  const challanRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [isSharing, setIsSharing] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 950);

  // --- PREVIEW SCALER ---
  useEffect(() => {
    const handleResize = () => {
      const isDesktopNow = window.innerWidth > 950;
      setIsDesktop(isDesktopNow);
      if (!isDesktopNow) {
        // Fit 900px paper into screen
        const availableWidth = window.innerWidth - 40; 
        const newScale = Math.min(availableWidth / 900, 1);
        setScale(newScale);
      } else {
        setScale(1);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const zoomIn = () => setScale(prev => Math.min(prev + 0.1, 1.5));
  const zoomOut = () => setScale(prev => Math.max(prev - 0.1, 0.3));

  // --- DOWNLOAD (Desktop) ---
  const downloadImage = async () => {
    try {
      const element = challanRef.current;
      const canvas = await html2canvas(element, CAPTURE_CONFIG);
      const link = document.createElement('a');
      link.download = `challan_${data.challanNumber}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (error) { console.error("Download failed:", error); }
  };

  // --- SHARE (Mobile) ---
  const handleShare = async () => {
    if (isSharing) return;
    setIsSharing(true);
    try {
      const element = challanRef.current;
      // USES ONCLONE FIX
      const canvas = await html2canvas(element, CAPTURE_CONFIG);
      
      canvas.toBlob(async (blob) => {
        const file = new File([blob], `challan_${data.challanNumber}.png`, { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({ title: 'Official Challan', text: `Challan issued to ${data.violatorName}.`, files: [file] });
          } catch (error) { if (error.name !== 'AbortError') console.error("Share error:", error); }
        } else {
          downloadImage(); // Fallback
        }
        setIsSharing(false);
      }, 'image/png');
    } catch (error) { console.error("Generation failed:", error); setIsSharing(false); }
  };

  // --- PDF DOWNLOAD ---
  const downloadPDF = async () => {
    const element = challanRef.current;
    // USES ONCLONE FIX
    const canvas = await html2canvas(element, CAPTURE_CONFIG);
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    const pdf = new jsPDF({ orientation: 'l', unit: 'mm', format: 'a4', compress: true });
    
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgProps = pdf.getImageProperties(imgData);
    
    let finalWidth = pageWidth;
    let finalHeight = (imgProps.height * pageWidth) / imgProps.width;
    
    if (finalHeight > pageHeight) {
      finalHeight = pageHeight;
      finalWidth = (imgProps.width * pageHeight) / imgProps.height;
    }
    
    const x = (pageWidth - finalWidth) / 2;
    const y = (pageHeight - finalHeight) / 2;
    
    pdf.addImage(imgData, 'JPEG', x, y, finalWidth, finalHeight, undefined, 'FAST');
    
    const qrCanvas = document.querySelector('canvas'); 
    if (qrCanvas) {
        const qrSize = finalWidth * 0.12; 
        const qrX = x + (finalWidth * 0.235);
        const qrY = y + (finalHeight * 0.22);
        pdf.addImage(qrCanvas.toDataURL(), 'PNG', qrX, qrY, qrSize, qrSize);
    }
    
    pdf.link(x, y + finalHeight - 15, finalWidth, 15, { url: 'https://challanednonchalant.netlify.app/' });
    pdf.save(`challan_${data.challanNumber}.pdf`);
  };

  return (
    <div className="challan-wrapper">
      <div className={!isDesktop ? "mobile-preview-box" : ""}>
        <div className="challan-scaler" style={{ transform: `scale(${scale})`, marginBottom: !isDesktop ? '50px' : '0' }}>
          <div className="challan-paper" id="challan-print" ref={challanRef}>
            <div className="challan-header">
              <img src={logo} alt="Logo" className="header-logo" />
              <div className="header-text">
                {data.relationshipType === 'Partner' ? (
                  <>
                    <h3 className="hindi-title">चालान-और लापरवाह पुरुष संघ</h3>
                    <h2 className="english-title">Challan-ed Non-Chalant Men Association</h2>
                    <p className="hindi-sub">(स्वस्थ पुरुष गुणों की खेती अधिनियम, 2026 उल्लंघन रिपोर्ट)</p>
                    <p className="english-sub">(Infringement Report under Cultivation of Healthy Masculine Virtues Act, 2026)</p>
                  </>
                ) : (
                  <>
                    <h3 className="hindi-title">चालान-और धोखेबाज़ मित्र संघ</h3>
                    <h2 className="english-title">Challan-Ed Non-Chalant Friends Association (CNCFA)</h2>
                    <p className="hindi-sub">(स्वस्थ मित्रता गुणों की खेती अधिनियम, 2026 उल्लंघन रिपोर्ट)</p>
                    <p className="english-sub">(Infringement Report under Cultivation of Healthy Friendship Virtues Act, 2026)</p>
                  </>
                )}
              </div>
            </div>

            <div className="image-row">
              <div className="img-box"><div className="relevant-text">Relevant<br/>Images<br/>&gt;&gt;&gt;</div></div>
              <div className="img-box">
                 <QRCodeCanvas value={`upi://pay?pa=${data.upiId}&pn=ChallanFine&am=${data.fineAmount}&cu=INR`} size={140} />
              </div>
              {[0, 1, 2].map((i) => (
                <div className="img-box" key={i}>
                  {data.evidenceImages[i] ? <img src={data.evidenceImages[i]} alt={`ev-${i}`} /> : <span style={{color: '#ccc', fontWeight: 'bold'}}>&lt;image {i+1}&gt;</span>}
                </div>
              ))}
            </div>

            <div className="details-box">
              <img src={logo} className="watermark" alt="watermark" />
              <div className="details-content">
                <div className="detail-line"><span className="label">Violator name:</span> {data.violatorName}</div>
                <div className="detail-line"><span className="label">Violation victim:</span> {data.victimName}</div>
                <div className="detail-line"><span className="label">Challan number:</span> {data.challanNumber}</div>

                <br/>
                <div className="detail-line"><span className="label">Date of incident:</span> {data.dateOfIncident}</div>
                <div className="detail-line"><span className="label">Place of incident:</span> {data.place}</div>
                
                <div className="detail-line"><span className="label">Is repeat violator?:</span> {data.repeatViolator}</div>

                <div className="offence-section">
                  <div className="offence-header">Offences charged with:</div>
                  <div className="offence-text">1. {data.offence}</div>
                  <div className="penalty-section">
                    <div className="penalty-hindi">ऊपर बताए गए जुर्म के लिए तय जुर्माना: <b>{data.fineAmount}/- रुपये</b></div>
                    <div className="penalty-english">Penalty specified against above offence charged: <b>{data.fineAmount}/- INR</b></div>
                    <div className="penalty-english" style={{marginTop: '4px'}}><b>Remarks:</b> {data.remarks}</div>
                    <br/>
                   
                  </div>
                </div>
              </div>
            </div>
          <p className="generated-line">Generated by National Informatics Centre for Heartbreak (NIC-H). Visit <a href='https://echalant.xyz/'>www.echalant.xyz</a> for more information.</p>
          </div>
        </div>
      </div>

      {!isDesktop && (
        <div className="zoom-controls">
           <div className="btn-zoom" onClick={zoomOut}>-</div>
           <div className="btn-zoom" onClick={zoomIn}>+</div>
        </div>
      )}

      <div className="action-buttons">
        {!isDesktop ? (
            <button className="btn-share" onClick={handleShare}>📤 Share Image</button>
        ) : (
            <button className="btn-share" onClick={downloadImage}>⬇️ Download Image</button>
        )}
        <button className="btn-secondary" onClick={downloadPDF}>Download PDF</button>
        <button className="btn-outline" onClick={onBack}>Edit Data</button>
      </div>
    </div>
  );
};

function App() {
  const [page, setPage] = useState('landing'); 
  const [challanData, setChallanData] = useState(null);
  const handleStart = () => setPage('form');
  const handleHome = () => setPage('landing'); 
  const handleFormSubmit = (data) => { setChallanData(data); setPage('display'); };
  const handleBack = () => setPage('form');

  return (
    <div className="app-container">
      <div className="disclaimer-bar">⚠️ <b>SATIRE ONLY:</b> This website is purely for entertainment. It is not affiliated with any government or private entity whatsoever.</div>
      {page === 'landing' && <LandingPage onStart={handleStart} />}
      {page === 'form' && <ChallanForm onSubmit={handleFormSubmit} onHome={handleHome} />}
      {page === 'display' && <ChallanDisplay data={challanData} onBack={handleBack} />}
    </div>
  );
}

export default App;